document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quantitystepper").forEach(function (stepper) {
    const input = stepper.querySelector(".quantitystepper__control-input");
    const decreaseBtn = stepper.querySelector(
      ".quantitystepper__control-button--decrease"
    );
    const increaseBtn = stepper.querySelector(
      ".quantitystepper__control-button--increase"
    );
    if (!input || !decreaseBtn || !increaseBtn) return;

    decreaseBtn.addEventListener("click", function () {
      let value = parseInt(input.value, 10) || 0;
      let min = parseInt(input.getAttribute("min"), 10) || 0;
      if (value > min) {
        input.value = value - 1;
        input.dispatchEvent(new Event("change"));
      }
    });

    increaseBtn.addEventListener("click", function () {
      let value = parseInt(input.value, 10) || 0;
      let max = input.hasAttribute("max")
        ? parseInt(input.getAttribute("max"), 10)
        : null;
      if (max === null || value < max) {
        input.value = value + 1;
        input.dispatchEvent(new Event("change"));
      }
    });
  });
});
